import { render, staticRenderFns } from "./CoinDetailsDialog.vue?vue&type=template&id=57ed3224&scoped=true&"
import script from "./CoinDetailsDialog.vue?vue&type=script&lang=js&"
export * from "./CoinDetailsDialog.vue?vue&type=script&lang=js&"
import style0 from "./CoinDetailsDialog.vue?vue&type=style&index=0&id=57ed3224&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ed3224",
  null
  
)

export default component.exports